<template>
	<div class="component-main">
		<div class="d-none d-md-block desktop-main" >
			<desktop-configure-slot-calendar/>
		</div>
	</div>
</template>
<script>
import DesktopConfigureSlotCalendar from './DesktopConfigureSlotCalendar'
//import EventBus from './../eventBus';
export default{
	name: 'ConfiguresSlots',
	components: {DesktopConfigureSlotCalendar},
	props: [],
	data(){
		return{

		}
	},
	created(){
	},
	methods: {

	},
	mounted(){

	}	
}

</script>
<style>
.component-main
{
	min-width: 320px;
}
// Extra small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) { }

// Small devices (landscape phones, less than 768px)
@media (max-width: 767.98px) { }

// Medium devices (tablets, less than 992px)
@media (max-width: 991.98px) { }

// Large devices (desktops, less than 1200px)
@media (max-width: 1199.98px) {  }

</style>